import React, { useState } from 'react';
import { Form, Input, Button, message, Switch, ConfigProvider } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/LoginPage.css';
import logo from '../uploads/logo.png';
import { Helmet } from 'react-helmet';
import { API_URL, API_username, API_password } from '../utils/api';

const LoginPage = () => {
  const [phone, setPhone] = useState('');
  const [mail, setMail] = useState('');
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [otp, setOTP] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMail, setMailAuth] = useState(true);
  const navigate = useNavigate();

  const handlePhoneSubmit = () => {
    if(!isMail) {
      if (phone.length !== 0) {
        if (phone.startsWith('9') && phone.length < 12) {
          const digits = 12 - phone.length;
          const message = digits === 1 ? `Не хватает ${digits} цифры` : `Не хватает ${digits} цифр`;
          message.error(message);
          return;
        } else if (phone.startsWith('7') && phone.length < 11) {
          const digits = 11 - phone.length;
          const message = digits === 1 ? `Не хватает ${digits} цифры` : `Не хватает ${digits} цифр`;
          message.error(message);
          return;
        } else {
          setLoading(true); // Устанавливаем состояние загрузки в true
          getOTP();
        }
      } else {
        message.error('Введите номер телефона!');
      }
    } else {
      setLoading(true); // Устанавливаем состояние загрузки в true
      getOTP();
    }
  };

  const getOTP = () => {
    let apiUrl = `${API_URL}/lk?method=auth-user&inbody=1`;
    let is_mail = isMail;
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`)
      },
      body: JSON.stringify({ phone, mail, is_mail })
    })
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else if (response.status === 202) {
        message.error('Сервер на данный момент перегружен!');
        return "error";
      } else if (response.status === 404) {
        message.error('Пользователь не найден!');
        return "error";
      } else {
        message.error('Произошла ошибка при отправке запроса!');
        return "error";
      }
    })
    .then(data => {
        if(data !== "error") {
          setShowOTPInput(true);
          localStorage.setItem('SessionId', data['SessionId']);
          localStorage.setItem('phone', phone);
          localStorage.setItem('status', 'waiting');
          if(phone) message.success(`На номер ${phone} отправлен код`);
          else message.success(`На почту ${mail} отправлен код`);          
        }
    }) 
    .catch(error => {
      message.error('Ошибка: ' + error.message);
    })
    .finally(() => {
      setLoading(false); // Устанавливаем состояние загрузки в false после получения ответа
    });
  };
  
  const login = () => {
    let apiUrl = `${API_URL}/lk?method=login&inbody=1`;
    let sessionId = localStorage.getItem("SessionId")
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
        'sessionid': sessionId
      },
      body: JSON.stringify({ 'auth_code': otp })
    })
    .then(response => {
      if (response.status === 200) {
        localStorage.setItem("status", "logged in");
        navigate('/dashboard');
      } else if (response.status === 202) {
        message.error('Сервер на данный момент перегружен!');
      } else if (response.status === 404) {
        setShowOTPInput(false);
        message.error('Сессия не найдена, попробуйте еще раз!');
      } else {
        message.error('Произошла ошибка при отправке запроса!');
      }
    })
    .catch(error => {
      message.error('Ошибка: ' + error.message);
    });
  };


  const handleOTPSubmit = () => {
    login();
  };

  const handlePhoneChange = e => {
    setPhone(e.target.value);
  };
  
  const handleMailChange = e => {
    setMail(e.target.value);
  };

  const handleOTPChange = e => {
    setOTP(e.target.value);
  };

  const handleBackToPhone = () => {
    setShowOTPInput(false);
  };

  return (
    <div className="login-page">
      <Helmet>
        <title>Вход в личный кабинет - Enter Engineering Pte. Ltd.</title>
      </Helmet>      
      <ConfigProvider
            theme={{
                token: {
                colorPrimary: 'rgba(194, 18, 39, 1)',
                colorPrimaryHover: 'rgba(194, 18, 39, .5)',
                },
            }}
        >
      <div className="login-box">
        <img className='login-page-logo' src={logo} alt="Logo" />
        <h4 style={{ marginTop: '20px', textAlign: 'center' }}>Вход в личный кабинет</h4>
        {/* <p style={{ display: "block", textAlign: "center", marginTop: "15px" }}>по <Switch style={{backgroundColor: isMail ? '#c21227' : 'green'}} value={isMail} onChange={()=>setMailAuth(!isMail)} size="small" checkedChildren="почте" unCheckedChildren="телефону" /></p> */}
        {!isMail && (<Form onFinish={showOTPInput ? handleOTPSubmit : handlePhoneSubmit}>
          <Form.Item style={{ marginTop: '10px' }}>
            {showOTPInput && (
              <span className="change-phone" onClick={handleBackToPhone}>
                {' < Сменить номер телефона'}
              </span>
            )}
          </Form.Item>
          {!showOTPInput && (
            <Form.Item
              name="phone"
              rules={[
                {
                  required: true,
                  message: 'Введите Ваш номер телефона!'
                }
              ]}
            >
              <Input value={phone} onChange={handlePhoneChange} placeholder="Номер телефона" maxLength="13" />
            </Form.Item>
          )}
          {showOTPInput && (
            <Form.Item
              name="otp"
              rules={[
                {
                  required: true,
                  message: 'Введите код, отправленный Вам на почту!'
                }
              ]}
            >
              <Input placeholder="Введите код из СМС" onChange={handleOTPChange} />
            </Form.Item>
          )}
          <Form.Item>
            {!showOTPInput ? (
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? 'Отправка...' : 'Отправить код'}
              </Button>
            ) : (
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? 'Подождите...' : 'Войти'}
              </Button>
            )}
          </Form.Item>
        </Form>)}
        {isMail && (<Form onFinish={showOTPInput ? handleOTPSubmit : handlePhoneSubmit}>
          <Form.Item style={{ marginTop: '10px' }}>
            {showOTPInput && (
              <span className="change-phone" onClick={handleBackToPhone}>
                {' < Сменить почту'}
              </span>
            )}
          </Form.Item>
          {!showOTPInput && (
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Введите адрес Вашей эл. почты!'
                },
                {
                  type: 'email',
                  message: 'Введите корректный адрес эл. почты!'
                }
              ]}
            >
              <Input value={mail} onChange={handleMailChange} placeholder="Электронная почта" />
            </Form.Item>
          )}
          {showOTPInput && (
            <Form.Item
              name="otp"
              rules={[
                {
                  required: true,
                  message: 'Введите код, отправленный Вам на почту!'
                }
              ]}
            >
              <Input placeholder="Введите код из письма" onChange={handleOTPChange} />
            </Form.Item>
          )}
          <Form.Item>
            {!showOTPInput ? (
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? 'Отправка...' : 'Отправить код'}
              </Button>
            ) : (
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? 'Подождите...' : 'Войти'}
              </Button>
            )}
            <Button type='primary' onClick={() => navigate('/candidate')} style={{ marginTop: '20px', backgroundColor: '#5b83a5', border: 'none' }}>Заполнить резюме</Button>
          </Form.Item>
        </Form>)}
      </div>
      </ConfigProvider>
    </div>
  );
};

export default LoginPage;
